{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              13.954438898348343,
              45.739763237702135
            ],
            [
              13.622196521016377,
              46.198826681090026
            ],
            [
              13.694881695646188,
              46.50776946756332
            ],
            [
              12.346418794422647,
              46.773354406438585
            ],
            [
              12.154275366892989,
              47.084796270257726
            ],
            [
              8.979293761835834,
              46.61917511215549
            ],
            [
              6.783350848031432,
              46.00771021155586
            ],
            [
              6.621227983991986,
              45.081950339179315
            ],
            [
              7.667409812162106,
              44.092675799108065
            ],
            [
              7.56355957122949,
              43.830651441108216
            ],
            [
              7.443073493399197,
              38.88766806564925
            ],
            [
              14.969832602976396,
              36.18354074264671
            ],
            [
              19.200980496296808,
              39.747219907622025
            ],
            [
              13.097078072655677,
              44.96653886906029
            ],
            [
              13.954438898348343,
              45.739763237702135
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}